export const sandboxMercadopago = false

export const configDev = {
  access_token: 'TEST-701495122867708-051314-590d9b0fd700e353086accc1fd813373-567567289'
}

export const configProd = {
  access_token: 'APP_USR-701495122867708-051314-75f6bd24f743dd88dfdd22691d254915-567567289'
}

export const configMercadopago = sandboxMercadopago ? configDev : configProd

export const urlPayment = {
  preference_url: 'https://api.mercadopago.com/checkout/preferences',
  return_url: 'https://us-central1-campus-tutiendaonline.cloudfunctions.net/payment'
}
